import { useLang } from '@/i18n/useLang'
import { useEffect } from 'react'
import { Outlet, useRouterState } from '@tanstack/react-router'
import { AnnouncementBar } from './components/AnnouncementBar'
import { Navbar } from './components/Navbar'
import { Footer } from './components/Footer'
import './marketing.css'

/** Public site chrome: announcement bar + navbar + footer around the page. */
export function MarketingLayout() {
  const { lang } = useLang()
  const pathname = useRouterState().location.pathname
  useEffect(() => {
    const elements = document.querySelectorAll('[data-animate], [data-animate-stagger]')
    if (!('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'))
      return
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
          observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0.05 })
    elements.forEach((element) => observer.observe(element))
    return () => observer.disconnect()
  }, [pathname])
  return (
    <div className="marketing-site min-h-screen flex flex-col">
      <a className="skip-content" href="#main-content">{lang === 'ru' ? 'К содержимому' : 'Skip to content'}</a>
      <AnnouncementBar />
      <Navbar />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
